import styled from 'styled-components'

const ExpandableListElementStyle = styled.div`
  > .expansionPanel {
    position: relative;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
    padding: ${(props) =>
      props.isExpanded ? (props.multiRow ? '12px 0 0 0' : '12px 0') : 0};
    border-radius: 4px !important;
    margin-bottom: 4px !important;

    &:hover,
    &.active {
      box-shadow: -5px 0px 0px 0px
        ${(props) => props.theme.palette.primary.main};
    }
  }

  > .expansionPanel ~ .expansionPanel {
    margin-bottom: 0 !important;
  }

  .header p {
    margin: 0;
  }

  .details {
    background: #fff;
    border-radius: 4px;
    display: grid;
    padding: 0;
  }

  .moreButton {
    margin-top: 6px;
  }

  .title {
    width: 100%;
  }

  .inputTitle {
    width: 908px;
    margin: 0 0 12px 0;
  }

  .moreButton {
    height: 24px;
    min-width: 24px;
    padding: 0;
    position: absolute;
    top: ${(props) => (props.isExpanded ? '11px' : '5px')};
    right: 16px;
  }

  .expansion-panel-summary-content {
    margin: 0 !important;
  }

  .expansion-panel-summary-expanded {
    min-height: 36px !important;
  }

  .expansion-panel-summary-expandIcon {
    right: 36px;
  }
`

export default ExpandableListElementStyle
